import { render, staticRenderFns } from "./columnar.vue?vue&type=template&id=2c15719b&scoped=true&"
import script from "./columnar.vue?vue&type=script&lang=js&"
export * from "./columnar.vue?vue&type=script&lang=js&"
import style0 from "./columnar.vue?vue&type=style&index=0&id=2c15719b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c15719b",
  null
  
)

export default component.exports